module.exports = __webpack_public_path__ + "img/banner.f9107f40.jpg";